import { Pipe, PipeTransform } from '@angular/core';
import { percentFormatter } from '@wilson/utils';

import { NumberFormatterPipe } from '../number-formatter/number-formatter.pipe';

/**
 * Formats a percentage on the 0-100 scale in the current language,
 * e.g. `87.35` → `87,35 %` (de-DE) or `87.35%` (en-GB).
 *
 * Use `ratioToPercent()` from `@wilson/utils` for ratios such as `0.8735`.
 * Follows language changes like {@link NumberFormatterPipe}.
 */
@Pipe({
  name: 'localizedPercent',
  pure: false,
})
export class LocalizedPercentPipe
  extends NumberFormatterPipe
  implements PipeTransform
{
  protected override formatValue(
    value: number,
    locale: string,
    options?: Intl.NumberFormatOptions,
  ): string {
    return percentFormatter(locale, options)(value);
  }
}
